import React from 'react';
import { Card, CardContent, TextField, Button, Modal } from '@material-ui/core';
import TagsInput from 'react-tagsinput'
import AutosizeInput from 'react-input-autosize'
import 'react-tagsinput/react-tagsinput.css'
class DocumentTags extends React.Component {
    render() {
        const { tags, description, onTagsChange, onDescriptionChange, onCancel, onConfirm, visible, onDescriptionBlur } = this.props;
        function autosizingRenderInput({ addTag, ...props }) {
            let { onChange, value, ...other } = props
            return (
                <AutosizeInput type='text' onChange={onChange} value={value} {...other} />
            )
        }
        const renderedTags = Object.keys(tags || {}).map((key) => {
            if (tags[key] === true) {
                return key;
            } else {
                return tags[key];
            }
        });
        return (
            <div>
                <Modal
                    open={visible}
                    onClose={onCancel}
                    disableBackdropClick
                    disableEscapeKeyDown
                    className='documentModal'
                >
                    <Card className="documentCard">
                        <CardContent>
                            <TagsInput renderInput={autosizingRenderInput} value={renderedTags} onChange={onTagsChange} />
                        </CardContent>
                        <CardContent>
                            <TextField
                                label="Description"
                                multiline
                                rows="4"
                                style={{
                                    width: '100%'
                                }}
                                margin="normal"
                                value={description}
                                onChange={onDescriptionChange}
                                onBlur={onDescriptionBlur}
                            />
                        </CardContent>
                        <Button
                            style={{ alignSelf: 'center', backgroundColor: 'white', color: 'black' }}
                            onClick={onCancel}
                        >
                            Cancel
                    </Button>
                        <Button
                            style={{ alignSelf: 'center', backgroundColor: 'white', color: 'black' }}
                            onClick={onConfirm}
                        >
                            Ok
                    </Button>
                    </Card>
                </Modal>
            </div>
        );
    }
}

export default (DocumentTags);


// WEBPACK FOOTER //
// ./src/components/common/DocumentTags.js